import { z } from 'zod';

/** The organization's FortMonitor account; the password never comes back. */
export const telematicsAccountSchema = z.object({
  configured: z.boolean(),
  login: z.string(),
  baseUrl: z.string(),
  updatedAt: z.string().nullable(),
});
export type TelematicsAccount = z.infer<typeof telematicsAccountSchema>;

export const updateTelematicsAccountSchema = z.object({
  login: z.string().trim().min(1, 'Введите логин API').max(200),
  password: z.string().min(1, 'Введите пароль API').max(500),
  baseUrl: z
    .union([z.literal(''), z.url({ protocol: /^https$/, message: 'Адрес https://…' })])
    .default(''),
});
export type UpdateTelematicsAccount = z.infer<typeof updateTelematicsAccountSchema>;

export const telematicsUnitSchema = z.object({
  objectId: z.number().int(),
  name: z.string(),
  imei: z.string(),
  status: z.number().int(),
  latitude: z.number(),
  longitude: z.number(),
  speed: z.number(),
  lastDataAt: z.string(),
  address: z.string(),
  sensors: z.array(z.object({ name: z.string(), value: z.string(), measuredAt: z.string() })),
  /** CRM equipment linked to this FortMonitor object. */
  equipmentId: z.string().nullable(),
  /** "" when FortMonitor does not tell; the duration looks like "1:39:03". */
  movement: z.enum(['moving', 'parked', '']),
  movementDuration: z.string(),
});
export type TelematicsUnit = z.infer<typeof telematicsUnitSchema>;

export const telematicsTrackSchema = z.object({
  objectId: z.number().int(),
  distanceKm: z.string(),
  points: z.array(
    z.object({ at: z.string(), latitude: z.number(), longitude: z.number(), speed: z.number() }),
  ),
});
export type TelematicsTrack = z.infer<typeof telematicsTrackSchema>;

export const telematicsUnitParamsSchema = z.object({
  organizationId: z.coerce.number().int().positive(),
  objectId: z.coerce.number().int().positive(),
});

export const telematicsTrackQuerySchema = z
  .object({
    startsAt: z.iso.datetime({ offset: true }),
    endsAt: z.iso.datetime({ offset: true }),
  })
  .refine((query) => Date.parse(query.endsAt) > Date.parse(query.startsAt), {
    message: 'Окончание должно быть позже начала',
    path: ['endsAt'],
  });
